<template>
  <v-container id="product-group-report" fluid tag="section">

    <FilterForm 
      :filter-form="filterForm"
      @click-search="search"
    />

    <ProductGroupTurnover
      :turnoverReport="turnoverReport"
    />

    <ProductGroupDensity
      :densityReport="densityReport"
    />

    <ProductGroupSold
      :filter-form="filterForm"
    />

  </v-container>
</template>
<script>

import FilterForm from './components/FilterForm'
import ProductGroupTurnover from './components/ProductGroupTurnover'
import ProductGroupDensity from './components/ProductGroupDensity'
import ProductGroupSold from './components/ProductGroupSold'

import { formatDate } from '../../../../helpers/utils'
import { colorChart } from '@/helpers/constants'
import * as moment from 'moment'
import * as ChartistTooltips from 'chartist-plugin-tooltips';

import RepositoryFactory from "@/repositories/RepositoryFactory";
const ReportRepository = RepositoryFactory.get('report');

export default {
  components: { 
    FilterForm,
    ProductGroupTurnover,
    ProductGroupDensity,
    ProductGroupSold,
  },
  data() {
    return {
      filterForm: {
        dateRange: {
          startDate: moment().startOf('days').format('YYYY-MM-DD 00:00:00'),
          endDate: moment().endOf('days').format('YYYY-MM-DD 23:59:59'),
        },
      },
      turnoverReport: {},
      densityReport: {},
    };
  },
  mounted() {
    this.search()
  },
  beforeDestroy () {
  },
  methods: {
    search (filterForm) {
      if(filterForm) {
        this.filterForm = filterForm
      }
      
      this.getReportTurnover()
      this.getReportDensity()
      Bus.$emit('sold-product-report-thpt')
    },

    // TurnOver
    async getReportTurnover() {
      const loader = this.$loading.show()
      const params = {
        startDateTime: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD 00:00:00'),
        endDateTime: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD 23:59:59'),
        duration: this.filterForm.dateRange.duration,
        schoolLevelIds: [2]
      };
      const responseTurnover = await ReportRepository.productGroupTurnover(params)

      loader.hide()

      if (responseTurnover.success) {
        const response = _.get(responseTurnover, 'data', {})
        this.turnoverReport = {
          labels: [],
          series: [],
          totalData: 0,
          products: [],
          color: colorChart
        };
        if(response.length < 1 ) {
          return
        }

        this.turnoverReport.totalData = response.length
        let dataGroups = response.dataGroups
        const map = [];
         response.productGroups.forEach( (day, key) => {
          this.turnoverReport.labels.push(...Object.keys(day))
          Object.keys(day).map((k) => {
            Object.values(dataGroups).map((productValue, index) => {
              if (!map[index]) map[index] = [];
              let tooltip = {
                meta: productValue + ' :',
                value: parseInt(day[k][productValue])
              } 
              map[index].push(tooltip);
            });
          })
        });

        Object.values(dataGroups).map(value => {
            this.turnoverReport.products.push(value)
        });
        this.turnoverReport.series.push(...map)
      }
    },

    // Density
    async getReportDensity() {
      const loader = this.$loading.show()
      const params = {
        startDateTime: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD 00:00:00'),
        endDateTime: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD 23:59:59'),
        duration: this.filterForm.dateRange.duration,
        schoolLevelIds: [2]
      };
      const responseDensity = await ReportRepository.productGroupDensity(params)

      loader.hide()

      if (responseDensity.success) {
        const response = _.get(responseDensity, 'data', {})
        this.densityReport = {
          series: [],
          labels: [],
          groupName: [],
          totalData: 0,
          color: colorChart
        }
        if(response.length < 1 ) {
          return
        }

        this.densityReport.totalData = response.length
        response.forEach(element => {
          this.densityReport.series.push({
            meta: _.get(element, 'product.group.name', '') + ' :',
            value: _.get(element, 'totalPricePercent', '')
          })
          this.densityReport.labels.push(_.get(element, 'totalPricePercent', 0) + '%')
          this.densityReport.groupName.push(_.get(element, 'product.group.name', ''))
        });
      }
    },

  }
};
</script>

<style lang="scss">
  #product-group-report {
    ul.description {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin: 10px 0;
      li {
        margin: 0 5px;
      }
    }
  }
</style>